/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-accountant.reducer';

export const HospitalAccountantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalAccountantEntity = useAppSelector(state => state.hospitalAccountant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalAccountantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalAccountant.detail.title">HospitalAccountant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.name">Name</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.email">Email</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.email}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.dateOfBirth}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.cursor}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.education">Education</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.education}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.experience}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.gender}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.hospitalAccountant.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{hospitalAccountantEntity.bloodGroup}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAccountant.tmUser">Tm User</Translate>
          </dt>
          <dd>{hospitalAccountantEntity.tmUser ? hospitalAccountantEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAccountant.hospital">Hospital</Translate>
          </dt>
          <dd>{hospitalAccountantEntity.hospital ? hospitalAccountantEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalAccountant.contactCode">Contact Code</Translate>
          </dt>
          <dd>{hospitalAccountantEntity.contactCode ? hospitalAccountantEntity.contactCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-accountant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-accountant/${hospitalAccountantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalAccountantDetail;
